/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const myAccount = {
  closeAccount: {
    confirmAccountClosure: 'Confirme o encerramento da conta',
    confirmAccountClosureMessage:
      'Tem certeza de que deseja encerrar sua conta?',
    closeMyAccount: 'FECHAR MINHA CONTA',
    accountClosedSuccessfully: 'Conta encerrada com sucesso',
    accountClosedFailure: 'A conta não pôde ser encerrada',
  },

  updatePasswordForm: {
    oldPassword: {
      label: 'Senha antiga',
      placeholder: 'Senha antiga',
    },
    oldPasswordIsRequired: 'É necessária uma senha antiga.',
    newPassword: {
      label: 'Nova senha',
      placeholder: 'Nova senha',
    },
    passwordMinRequirements:
      'A senha deve ter no mínimo seis caracteres, com letra maiúscula, número e símbolo',
    confirmPassword: {
      label: 'Confirme a nova senha',
      placeholder: 'Confirme a senha',
    },
    bothPasswordMustMatch: 'Ambas as senhas devem corresponder',
    passwordUpdateSuccess: 'Senha atualizada com sucesso',
    accessDeniedError: 'Acesso negado',
  },
  updateProfileForm: {
    title: 'Título',
    none: '',
    firstName: {
      label: 'Nome',
      placeholder: 'Nome',
    },
    firstNameIsRequired: 'O nome é obrigatório.',
    lastName: {
      label: 'Sobrenome',
      placeholder: 'Sobrenome',
    },
    lastNameIsRequired: 'Sobrenome obrigatório.',
    profileUpdateSuccess: 'Os dados pessoais foram atualizados com sucesso',
    customerId: 'Cliente #',
  },
  consentManagementForm: {
    clearAll: 'Apagar tudo',
    selectAll: 'Selecionar tudo',
    message: {
      success: {
        given: 'Consentimento concedido com sucesso.',
        withdrawn: 'Consentimento retirado com sucesso.',
      },
    },
  },
  myCupoms: {
    noCupomsMessage: 'Você não tem cupons disponíveis.',
    effectiveTítulo: 'Eficaz:',
    Eficaz: 'EFICAZ',
    PreSession: 'EFETIVO EM BREVE',
    ExpireSoon: 'EXPIRA EM BREVE',
    readMore: 'Ler mais',
    notification: 'Notificação',
    findProducts: 'Pesquisar produtos',
    status: 'Estado:',
    dialogTítulo: 'Cupom',
    claimCustomerCupom: 'Você reivindicou este cupom com sucesso.',
    myCupoms: 'Meus cupons',
    startDateAsc: 'Data de Início (Crescente)',
    startDateDesc: 'Data de Início (Decrescente)',
    endDateAsc: 'Data de término (crescente)',
    endDateDesc: 'Data de Término (Decrescente)',
    sortBy: 'Classificar por',
    sortCupoms: 'Solicitar cupons',
    notesPreffix:
      'Você pode configurar seus canais preferidos para receber notificações de cupons no ',
    notesLink: 'Notificação Channels',
    notesSuffix: ' página.',
  },
  notificationPreference: {
    message: 'Selecione seus canais de notificação preferidos',
    note: 'Nota: ',
    noteMessage:
      'Se você desativar todos os canais, não poderá receber mais notificações.',
    EMAIL: 'Email:',
    SMS: 'SMS:',
    SITE_MESSAGE: 'Mensagem do site',
  },
  myInterests: {
    header: 'Meus interesses',
    item: 'ARTIGO',
    price: 'PREÇO',
    notifications: 'NOTIFICAÇÕES',
    noInterests: 'Você ainda não tem nenhum interesse registrado.',
    inStock: 'Em stock',
    lowStock: 'Baixo stock',
    outOfStock: 'Sem stock',
    BACK_IN_STOCK: 'Voltar ao porta-malas',
    sortBy: 'Classificar por',
    sortInterests: 'Classificar interesses',
    expirationDate: ' - Um {{ expirationDate }}',
    productId: 'ID {{ code }}',
    remove: 'Eliminar',
    sorting: {
      byNameAsc: 'Número (ascendente)',
      byNameDesc: 'Número (descendente)',
    },
    actions: 'AÇÕES',
    caption: 'Meus interesses estão felizes.',
    itemEliminard: 'O item selecionado foi excluído.',
  },
};
